import React from 'react';
import { useApp } from '../../../../context/app';
import { GerenciarProjetosAcoes } from './GerenciarProjetosAcoes';
import { IncluirProjetoAcoes } from './IncluirProjetoAcoes';

export const ProjetosAcoes = () => {
  const { renderIncludeScreen } = useApp();
  return renderIncludeScreen ? (
    <IncluirProjetoAcoes />
  ) : (
    <GerenciarProjetosAcoes />
  );
};
